import { useMutation, UseMutationResult } from "react-query";
import { localConfig } from "../../../Configs/localConfig";
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert";
import { api } from "../../api";

interface ParamsDeleteVariedade {
  cod_atribuicao: number,
  refetch_deletar: Function;
}

export const useDeleteAtribuicao = (): {
carregando_deletar_atribuicao: boolean
mudate_deletar_atribuicao: (params: ParamsDeleteVariedade) => void
} => {
const mutation: UseMutationResult<Response, Error, ParamsDeleteVariedade> = useMutation(
  async (params: ParamsDeleteVariedade) => {
    const {
      cod_atribuicao,
     refetch_deletar
    } = params

    const config = localConfig()

    loadingAlert({ msg: 'Excluindo...', id: 'delete_atribuicao' })

    return api
      .delete(
        `/usuario/${cod_atribuicao}?codConta=${config.conta}&codCliente=${config.codCliente}`
      )
      .then((response: any) => {
        successAlert('Excluído com sucesso!', 5000, 'delete_atribuicao')
        refetch_deletar?.()
        return response
      })
      .catch((error: Error) => {
        //@ts-ignore
        let error_response = error?.response?.data
        errorAlert(error_response?.error ?? 'Falha ao excluir atribuicao', 5000, 'delete_atribuicao')

        throw error
      })
  }
)

return {
  carregando_deletar_atribuicao: mutation.isLoading,
  mudate_deletar_atribuicao: mutation.mutate,
}
}